// extracted by mini-css-extract-plugin
export default {"AboutUs":"AboutUs_AboutUs__nznLf","content":"AboutUs_content__C9uFE"};